export default "__VITE_ASSET__3i$_l1OK__"